import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserWithGoogleState {
    currentUser: any[];
}

const initialState: UserWithGoogleState = {
    currentUser: [null, {
        email: null,
        auth: "user",
        secondaryAuth: "any"
    }, false]
};

const userWithGoogle = createSlice({
    name: 'GoogleUser',
    initialState,
    reducers: {
        setCurrentUser: (state, action: PayloadAction<any[]>) => {
            state.currentUser = action.payload;
        }
    }
})

export const {setCurrentUser} = userWithGoogle.actions

export default userWithGoogle.reducer
